import React, {useEffect, useState } from "react"
import Sidebar from "./Sidebar.js";
import EditBar from "./EditBar.js";

import { BlueprintJS } from '../blueprintSrc/scripts/blueprint.js';
import { EVENT_LOADED, EVENT_NOTHING_2D_SELECTED, EVENT_CORNER_2D_CLICKED, EVENT_WALL_2D_CLICKED, EVENT_ROOM_2D_CLICKED, EVENT_WALL_CLICKED, EVENT_ROOM_CLICKED, EVENT_NO_ITEM_SELECTED, EVENT_ITEM_SELECTED, EVENT_GLTF_READY, EVENT_DOOR_2D_CLICKED, EVENT_FLOOR_ITEM_2D_CLICKED, EVENT_OPEN_WINDOW_SET, EVENT_LOG_IN } from '../blueprintSrc/scripts/core/events.js';
import { Configuration, configDimUnit, viewBounds } from '../blueprintSrc/scripts/core/configuration.js';
import { dimCentiMeter } from '../blueprintSrc/scripts/core/constants.js';

import * as default_room_json from '../blueprintSrc/empty_room.json';

import swal from 'sweetalert';
import { ApiCalls } from "./apiCalls.js";
import { GLTFExporter } from "three/examples/jsm/exporters/GLTFExporter";
import { Scene } from "three/build/three.module";
import { Mesh } from "three/build/three.module";
import { Vector3 } from "three/build/three.module";
import { BufferGeometry } from "three/build/three.module";
import { BufferAttribute } from "three/build/three.module";
import { MeshStandardMaterial } from "three/build/three.module";
import 'dotenv/config'

const Main = (props)=>{

    // setting up the object for the state
    let stateObj = {
        blueprint3d: {},
    }

    let data;
    if (default_room_json.default === undefined) {
        data = JSON.stringify(default_room_json)
    } else {
        data = JSON.stringify(default_room_json.default)
    }
    const [floorList, setFloorList] = useState([{
        name: "default room",
        data: data
    }])//set default room
    const [currentFloor, setCurrentFloor] = useState(0);
    const [state, setState] = useState(stateObj);

    const [orgId, setOrgId] = useState(0);
    const [projectId, setProjectId] = useState(0);

    const [apiCaller] = useState(new ApiCalls());

    const [selected2DEntity, setSelected2DEntity] = useState({isSelected:false, type: ""});

    const [showWindowSettings, setShowWindowSettings] = useState(false);
    
    const [floorplannerMode, setFloorplannerMode] = useState(null);

    const [scenesToExport, setScenesToExport] = useState([]);
    const [currentFloorTracker, setCFT] = useState(0);

    useEffect(()=>{
        let bp = new BlueprintJS({
            viewer2d: {
                id: 'bp3djs-viewer2d',
                viewer2dOptions: {
                    'corner-radius': 12.5,
                    'boundary-point-radius': 5.0,
                    'boundary-line-thickness': 2.0,
                    'boundary-point-color': '#030303',
                    'boundary-line-color': '#090909',
                    pannable: true,
                    zoomable: true,
                    scale: false,
                    rotate: true,
                    translate: true,
                    dimlinecolor: '#3E0000',
                    dimarrowcolor: '#FF0000',
                    dimtextcolor: '#000000',
                    pixiAppOptions: {
                        resolution: 1,
                    },
                    pixiViewportOptions: {
                        passiveWheel: false,
                    }
                },
            },
            viewer3d: {
                id: 'bp3djs-viewer3d',
                viewer3dOptions: {
                    occludedWalls: false,
                    occludedRoofs: false
                }
            },
            textureDir: "models/textures/",
            widget: false,
            resize: true,
        });

        //Configuration settings
        Configuration.setValue(viewBounds, 10000);//In CMS
        Configuration.setValue(configDimUnit, dimCentiMeter);

        state.blueprint3d = bp;
        
        // Initialize floorplanner mode state
        setFloorplannerMode(bp.floorplanner.__mode);

        //event listeners
        state.blueprint3d.model.addEventListener(EVENT_LOADED, (evt)=>{
            console.log("LOADED")
            state.blueprint3d.floorplanner.__redrawFloorplan();
        });

       state.blueprint3d.roomplanner.addRoomplanListener(EVENT_GLTF_READY, function (evt) {
            evt.sendToHegias ? sendBlueprint3DToHegias(evt) : downloadGlb(evt);
        });

        state.blueprint3d.roomplanner.addRoomplanListener("SCENE_EXPORTED", function(evt){
            let tmp = evt.scene.clone();
            scenesToExport.push({scene: tmp, height: evt.wallHeight});
            if(scenesToExport.length<floorList.length){
                setFloor(null, scenesToExport.length);
                state.blueprint3d.roomplanner.exportSceneAsGTLF(evt.sendToHegias, true);
            }else{
                let newScene = new Scene();

                // translate the scenes
                let translation = 0;
                
                // merge floor scenes in a single scene
                scenesToExport.forEach((el) =>{
                    el.scene.children.forEach((child)=>{
                        //only from the first floor onward we need  an extra wall for the gaps
                        if (translation === 0) {
                            newScene.add(child.clone().translateY(translation));
                        } else {
                            if (child.name === 'ceiling') {
                                console.log(child);
                                let floormesh = child.clone().translateY(translation-el.height/100);
                                floormesh.geometry = child.clone().geometry.clone();
                                let vertices = floormesh.geometry.vertices;
                                vertices.forEach( v => {
                                    v.multiplyScalar(0.01);
                                    v.add(floormesh.position)
                                })
                                for (let index = 0; index < vertices.length; index++) {//create the covers for the gaps
                                    let v1 = vertices[index];
                                    let v2 = (index === vertices.length - 1)? vertices[0] : vertices[index+1];
                                    let v3 = v1.clone().add(new Vector3(0,-0.3,0));
                                    let v4 = v2.clone().add(new Vector3(0,-0.3,0));
                                    let bufferVertex = [v1.x, v1.y, v1.z,
                                                        v2.x, v2.y, v2.z,
                                                        v3.x, v3.y, v3.z,
                                                        v3.x, v3.y, v3.z,
                                                        v4.x, v4.y, v4.z,
                                                        v2.x, v2.y, v2.z]
                                    let newGeometry = new BufferGeometry();
                                    newGeometry.setAttribute('position', new BufferAttribute(new Float32Array(bufferVertex), 3));
                                    newGeometry.computeVertexNormals();
                                    let mat = new MeshStandardMaterial();
                                    mat.name = "White Concrete 13";
                                    let newMesh = new Mesh(newGeometry, mat);
                                    newMesh.name = "wall";
                                    newScene.add(newMesh);
                                }
                            }else if(child.name=="floor"){
                                console.log(child);
                                console.log(translation);
                            }
                            
                            newScene.add(child.clone().translateY(translation));
                        }
                        
                    });
                    translation += el.height/100+0.3;
                });
                let exporter = new GLTFExporter();
                exporter.parse(newScene, (glb)=>{
                    if(evt.sendToHegias){
                        sendBlueprint3DToHegias({gltf:glb, evt:evt});
                        return
                    }
                    let data = glb;
                    let a = window.document.createElement('a');
                    let blob = new Blob([data], { type: 'application/octet-stream' });
                    a.href = window.URL.createObjectURL(blob);
                    a.download = 'design.glb';
                    document.body.appendChild(a);
                    a.click();
                    document.body.removeChild(a);
                }, {binary: true, onlyVisible:false});

                setFloor(null, currentFloorTracker);

                // reset everything
                setCFT(0);
                setScenesToExport([]);
            }
        });

        state.blueprint3d.floorplanner.addFloorplanListener(EVENT_NOTHING_2D_SELECTED, ()=>{
            setSelected2DEntity({isSelected:false, type:""});
        });

        state.blueprint3d.floorplanner.addFloorplanListener( EVENT_WALL_2D_CLICKED, ()=>{
            setSelected2DEntity({isSelected: true, type: "wall"});
        });

        state.blueprint3d.floorplanner.addFloorplanListener(EVENT_CORNER_2D_CLICKED, ()=>{
            setSelected2DEntity({isSelected: true, type: "corner"});
        });

        state.blueprint3d.floorplanner.addFloorplanListener(EVENT_ROOM_2D_CLICKED, ()=>{
            setSelected2DEntity({isSelected: true, type: "room"});
        });

        state.blueprint3d.floorplanner.addFloorplanListener("FLOORPLANNER_MODE_MOVE", ()=>{
            // if we are in move mode we shouldn't see the window settings anymore
            setShowWindowSettings(false);
        });

        state.blueprint3d.floorplanner.addFloorplanListener(EVENT_OPEN_WINDOW_SET, ()=>{
            // we have to show the window settings
            setShowWindowSettings(true);
        })

        state.blueprint3d.model.loadSerialized(floorList[0].data);

    },[]);

    // function that handles the request to send the blueprint to hegias
    const sendBlueprint3DToHegias = (evt) => {
        let sceneNameInput = document.createElement('input');
        sceneNameInput.setAttribute('id', "sceneNameid");
        swal({
            content: {
                element:'input',
                attributes: {
                    placeholder: "Insert scene name",
                    type: "text",
                },
            },
            button: "Create HEGIAS Scene"
        })
        .then((value)=>{

            if(value === null){
                return;
            }

            swal({
                text:"Uploading project, please wait!",
                buttons: false,
                closeOnEsc: true,
                closeOnClickOutside: true
            });
            console.log(value);
            console.log(evt);
            apiCaller.createSceneOverload(evt.orgId, evt.projectId, evt.gltf, value);
           //apiCaller.getOrgId(evt, value);
        })
    }

    const downloadGlb = (evt) => {
        let data = evt.gltf;
        let a = window.document.createElement('a');
        let blob = new Blob([data], { type: 'application/octet-stream' });
        a.href = window.URL.createObjectURL(blob);
        a.download = 'design.glb';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    }

    //delete the current selected floor, return true if the floor has been deleted;
    const deleteCurrentFloor = () => {
        if (floorList.length === 1) {
            return false;
        }
        if (floorList.length !== 0) {
            
            if (currentFloor === 0) {
                floorList.splice(currentFloor, 1);
                //I need to force the rerender since it do not rerender if the value do not change
                state.blueprint3d.model.loadSerialized(floorList[0].data);
            } else {
                floorList.splice(currentFloor, 1);
                setCurrentFloor(floorList.length - 1)
                state.blueprint3d.model.loadSerialized(floorList[floorList.length -1].data)
            }
            return true;
        }
    }

    //load the selected floor in the viewer
    const setFloor = (ev, value = null) =>{
        let index = 0;
        if (value !== null) {
            index = value;
        } else {
            index = ev.target.value;
        }
        
        let data = state.blueprint3d.model.exportSerialized(); //save current data
        floorList[currentFloor].data = data;
        setCurrentFloor(index)
        state.blueprint3d.model.loadSerialized(floorList[index].data);
        
    }

    const nextFloor = () => {
        if (currentFloor >= floorList.length - 1) {return}
        setFloor(null, currentFloor + 1)
    }

    const previousFloor = () => {
        if (currentFloor === 0) {return}
        setFloor(null, currentFloor - 1)
    }

    // add a floor in the floor list at the end
    const addFloor =()=> {
        let newData;
        let j = default_room_json;
        if (j.default === undefined) {
            newData = j
        } else {
            newData = j.default;
        }
        let newFloor = {
            name : ("new floor " + floorList.length),
            data : JSON.stringify(newData)
        }

        let data = state.blueprint3d.model.exportSerialized()

        floorList[currentFloor].data = data;//save current floor
        floorList.push(newFloor)//add new floor
        setCurrentFloor(floorList.length - 1)
        state.blueprint3d.model.loadSerialized(floorList[floorList.length -1].data); 
    }

    const switchViewer = ()=> {
        //TODO: change settings to side bar
        state.blueprint3d.switchView();
    }

    const switchViewer2DToFloorItemAdd = (itemName) => {
        //TODO: FIX THIS
        state.blueprint3d.setViewer2DModeToFloorItemAdd(state.blueprint3d.roomplanner, state.blueprint3d.roomplanningHelper, state.blueprint3d.floorplanningHelper, itemName);
    }

    const switchViewer2DToWindowAdd = ()=> {
        state.blueprint3d.setViewer2DModeToWindowAdd(state.blueprint3d.roomplanner, state.blueprint3d.roomplanningHelper, state.blueprint3d.floorplanningHelper);
        setFloorplannerMode(state.blueprint3d.floorplanner.__mode);
    }
    
    const switchViewer2DToDoorAdd =() => {
        // passing around the 3d viewer
        state.blueprint3d.setViewer2DModeToDoorAdd(state.blueprint3d.roomplanner, state.blueprint3d.roomplanningHelper, state.blueprint3d.floorplanningHelper);
        setFloorplannerMode(state.blueprint3d.floorplanner.__mode);
    }
    
    const switchViewer2DToDraw = () => {
        state.blueprint3d.setViewer2DModeToDraw();
        setFloorplannerMode(state.blueprint3d.floorplanner.__mode);
    }
    
    const switchViewer2DToMove = () => {
       state.blueprint3d.setViewer2DModeToMove();
       setFloorplannerMode(state.blueprint3d.floorplanner.__mode);
    }
    
    //TODO: FIX THIS
    const switchViewer2DToTransform = () => {
        state.blueprint3d.switchViewer2DToTransform();
        setFloorplannerMode(state.blueprint3d.floorplanner.__mode);
    }
    
    const loadBlueprint3DDesign = (filedata) => {
        let reader = new FileReader();
        reader.onload = function (event) {
            let data = event.target.result;
            state.blueprint3d.model.loadSerialized(data);//function to load the plan
        };
        reader.readAsText(filedata);
        
    }
    
    const saveBlueprint3DDesign = () =>{
        //TODO can this function save multiple floors? 
        let data = state.blueprint3d.model.exportSerialized();
        let a = window.document.createElement('a');
        let blob = new Blob([data], { type: 'text' });
        a.href = window.URL.createObjectURL(blob);
        a.download = 'design.blueprint3d';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    }
    
    // exports every floor in a single glb
    const saveAllFloorsAsGlb = (sendToHegias = false) =>{
        setCFT(currentFloor);
        setFloor(null, 0);
        state.blueprint3d.roomplanner.exportSceneAsGTLF(sendToHegias, true);;
    }

    const saveBlueprint3D = (sendToHegias = false) => {
        state.blueprint3d.roomplanner.exportSceneAsGTLF(sendToHegias);
    }

    const saveBlueprint3DNew = (sendToHegias = false, orgId = 0, projectId = 0) => {
        state.blueprint3d.roomplanner.exportSceneAsGTLF(sendToHegias, false, orgId, projectId);
    }

    const setDragOnlyX = (isDragX)=>{
        state.blueprint3d.configurationHelper.dragOnlyX =isDragX;
    }

    const setDragOnlyY = (isDragY)=>{
        state.blueprint3d.configurationHelper.dragOnlyY =isDragY;
    }

    const setDirectionalDrag= (isDrag)=>{
        state.blueprint3d.configurationHelper.directionalDrag =isDrag;
    }

    const setSnapToGrid = (snap)=>{
        state.blueprint3d.configurationHelper.snapToGrid =snap;
    }

    const setGridSpacing = (newSpacing)=>{
        state.blueprint3d.configurationHelper.gridSpacing = newSpacing;
    }

    const reset = ()=>{
        state.blueprint3d.model.reset();
    }

    const updateFloorplan = ()=>{
        state.blueprint3d.model.floorplan.update();
    }

    const resetSelected2DEntity = ()=>{
        setSelected2DEntity({isSelected:false, type:""});
    }

    const hideWindowSettings = ()=>{
        setShowWindowSettings(false);
    }

    // console.log(state?.blueprint3d?.floorplanner?.__mode);
    
    return (
        <>
            <Sidebar 
                logOut={props.logOut}
                switchViewer={switchViewer}

                floorplannerMode={floorplannerMode}
                switchToMove={switchViewer2DToMove}
                switchToDraw={switchViewer2DToDraw}
                switchToTransform={switchViewer2DToTransform}
                switchToDoorAdd={switchViewer2DToDoorAdd}
                switchToWindowAdd={switchViewer2DToWindowAdd}
                switchToItemAdd={switchViewer2DToFloorItemAdd}
                
                setDragOnlyX={setDragOnlyX}
                setDragOnlyY={setDragOnlyY}
                setDirectionalDrag={setDirectionalDrag}
                setSnapToGrid={setSnapToGrid}
                setGridSpacing={setGridSpacing}

                setOrgId={setOrgId}
                setProjectId={setProjectId}

                saveAllFloorsAsGlb = {saveAllFloorsAsGlb}
                saveBlueprint3D={saveBlueprint3D}
                saveBlueprint3DNew={saveBlueprint3DNew}
                saveBlueprint3DDesign = {saveBlueprint3DDesign}
                loadBlueprint3DDesign = {loadBlueprint3DDesign}

                reset = {reset}

                selected2DEntity={setSelected2DEntity}
                hideWindowSettings={hideWindowSettings}
            />
            <div id="bp3djs-viewer2d"></div>
            <div id="bp3djs-viewer3d"></div>
            <EditBar    deleteCurrentFloor={deleteCurrentFloor}
                        addFloor={addFloor}
                        setFloor={setFloor}
                        nextFloor={nextFloor}
                        previousFloor={previousFloor}
                        floorNumber={floorList.length}
                        floorSelected={currentFloor}

                        selected2DEntity = {selected2DEntity}
                        floorplanningHelper = {state.blueprint3d.floorplanningHelper}
                        updateFloorplan={updateFloorplan}
                        resetSelected2DEntity = {resetSelected2DEntity}

                        showWindowSettings={showWindowSettings}
                        floorplanner = {state.blueprint3d.floorplanner}
            />
        </>
    )

}

export default Main;